module.exports = __webpack_public_path__ + "img/16.b22154dd.jpg";